import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS } from '../../../styles/variables';
import { device } from '../../../styles/devices';

export const BodyStyleFrame = styled(animated.div)`
  padding: 24px 6px 32px 6px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 12px;

  @media ${device.laptop} {
    padding: 24px;
  }
`;

export const BodyButton = styled.button<{ isSelected: boolean; isAvailable: boolean }>`
  background: ${({ isSelected }) => (isSelected ? COLORS.grey15 : 'inherit')};
  border: 1px solid ${COLORS.grey15};
  padding: 6px 12px;
  font-size: 16px;
  line-height: 24px;
  font-family: Audi Type;
  color: ${COLORS.black};
  display: flex;
  flex-direction: row;
  gap: 12px;
  cursor: pointer;
  :disabled {
    cursor: not-allowed;
  }
  color: ${({ isAvailable, isSelected }) => {
    if (!isAvailable) return COLORS.grey30;
    if (isSelected) return COLORS.black;
    return COLORS.grey80;
  }};
`;

export const Label = styled.p<{ isSelected: boolean; isAvailable: boolean }>`
  font-weight: ${({ isSelected }) => isSelected && 700};
  color: ${({ isAvailable }) => (!isAvailable ? COLORS.grey30 : COLORS.grey80)};
  color: ${({ isSelected }) => isSelected && COLORS.black};
  font-size: 12px;
  line-height: 20px;
`;
